import Typography from '@setproduct-ui/core/Typography';
import React, { ComponentProps } from 'react';

export const H1 = ({ children, ...rest }: ComponentProps<typeof Typography>) => (
  <Typography type="h1" tagName="h1" {...rest}>
    {children}
  </Typography>
);
